import { defineComponent as r, inject as a, h as n } from "vue";
import { dataTableInjectionKey as i } from "./ghl-ui.es949.js";
import c from "./ghl-ui.es162.js";
const l = r({
  name: "DataTableBodyRadio",
  props: {
    rowKey: {
      type: [String, Number],
      required: !0
    },
    disabled: {
      type: Boolean,
      required: !0
    },
    onUpdateChecked: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedCheckedRowKeySetRef: t,
      componentId: d
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = a(i);
    return () => {
      const { rowKey: o } = e;
      return n(c, { name: d, disabled: e.disabled, checked: t.value.has(o), onUpdateChecked: e.onUpdateChecked });
    };
  }
});
export {
  l as default
};
